import { MessageBox } from "element-ui";
import i18nLocale from "@/helpers/locale";

const countDownAlert = ({
  content = "",
  delayTime = 3000,
  callback
}) => {
  let text = `
    <i class="el-icon-check egl-confirm-success"></i>
    <span class="result-text">${content}</span>
    <span class="count-down">（${i18nLocale("global.disappearAfter3s")}）</span>`;

  MessageBox.alert(text, "", {
    dangerouslyUseHTMLString: true,
    showClose: false,
    showCancelButton: false,
    showConfirmButton: false,
    customClass: "egl-confirm",
  });

  const [ msgBoxWrapper ] = document.getElementsByClassName("el-message-box__wrapper");
  msgBoxWrapper.className += " transparent-bg";

  setTimeout(function() {
    msgBoxWrapper.className = "el-message-box__wrapper";
    MessageBox.close();

    if (typeof callback === "function") {
      callback();
    }
  }, delayTime);
};

export default countDownAlert;